import React from "react";
// import Image from "next/image";
// import Link from "next/link";
import { Link } from "react-router-dom";
import "./footer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
export default function Footer() {
  return (
    <footer className="footer-main">

      {/* ===== TOP NEWSLETTER SECTION ===== */}
      <div className="footer-newsletter">
        <div className="footer-newsletter-content">
          <h2 className="footer-newsletter-title">Join Our Newsletter</h2>
          <p className="footer-newsletter-subtitle">
            Get updates on Offers, Events
          </p>

          <form className="footer-newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              className="footer-newsletter-input"
            />
            <button className="footer-newsletter-button">Submit</button>
          </form>
        </div>
      </div>

      {/* ===== MIDDLE PAYMENT SECTION ===== */}
      <div className="footer-payment">
      <div className="footer-payment-two">
        <p className="footer-payment-text">Affilated With</p>
        <div className="footer-payment-icons">
          <img src="/img/company/nepal.webp" alt="Visa" width={70} height={50} />
          <img src="/img/company/tourismboard.webp" alt="Mastercard" width={70} height={50} />
          <img src="/img/company/natta.webp" alt="eSewa" width={70} height={50} />
          <img src="/img/company/taan.webp" alt="Visa" width={70} height={50} />
        </div>
        </div>
        <div className="footer-payment-two">
        <p className="footer-payment-text">We Accept</p>
        <div className="footer-payment-icons">
          <img src="/img/company/visa.webp" alt="Visa" width={30} height={30} />
          <img src="/img/company/Master-Card.png" alt="Mastercard" width={35} height={30} />
          <img src="/img/company/paypal.webp" alt="eSewa" width={40} height={30} />
           <img src="/img/company/wechat.webp" alt="eSewa" width={27} height={30} />
          <img src="/img/company/str.png" alt="eSewa" width={40} height={30} />
          <img src="/img/company/american.webp" alt="eSewa" width={40} height={30} />
        </div>
        </div>
      </div>

      {/* ===== MAIN FOOTER LINKS SECTION ===== */}
      <div className="footer-links-section">
        <div className="footer-links-grid">

          {/* Box 1 */}
          <div className="footer-box">
            <h4 className="footer-box-title">Quick Links</h4>
            <ul className="footer-box-list">
              <li><Link to="/Home">Home</Link></li>
              <li><Link to="/contactus">Contact Us</Link></li>
              <li><Link to="/nepal-tour">Nepal Tour</Link></li>
            </ul>
          </div>

          {/* Box 2 */}
          <div className="footer-box">
            <h4 className="footer-box-title">Packages</h4>
            <ul className="footer-box-list">
              <li><Link to="kathmandu-chitwan-pokhara-8days-nepaltour">Best Seller</Link></li>
              <li><Link to="kathmandu-chitwan-nagarkot">Peak & Safaris</Link></li>
              <li><Link to="One-Day-Kathmandu-Tour">The Big Four</Link></li>
            </ul>
          </div>

          {/* Box 3 */}
          <div className="footer-box">
            <h4 className="footer-box-title">Company</h4>
            <ul className="footer-box-list">
              <li><Link to="/aboutus">About Us</Link></li>
              <li><Link to="/meetourfounder">Meet Our Founder</Link></li>
              <li><Link to="/legal">Legal Document</Link></li>
            </ul>
          </div>

          {/* Box 4 */}
          <div className="footer-box">
            <h4 className="footer-box-title">Customer Care</h4>
            <ul className="footer-box-list">
              <li><Link to="/faqs">FAQs</Link></li>
              <li><Link to="/contactus">Support</Link></li>
              <li><Link to="/Terms">Terms & Conditions</Link></li>
            </ul>
          </div>

        </div>
      </div>

      {/* ===== BOTTOM COPYRIGHT SECTION ===== */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2026 Himalayas Travels Pvt. Ltd. All rights reserved.
        </p>

        <div className="footer-socials">
          <Link to="https://www.facebook.com/profile.php?id=61590545644233" target="_blank"><FontAwesomeIcon icon={faFacebook}/></Link>
          <Link to="https://www.instagram.com/himalayastravelsofficial/" target="_blank"><FontAwesomeIcon icon={faInstagram}/></Link>
          <Link  to="https://www.youtube.com/channel/UCj-bEPS5hTJ-vcvdWlH6Cbg" target="_blank"><FontAwesomeIcon icon={faYoutube}/></Link>
          <Link to="https://www.tiktok.com/@himalayastravelsofficial" target="_blank"><FontAwesomeIcon icon={faTiktok}/></Link>
        </div>
      </div>

    </footer>
  );
}